import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';
import { IListini, IProfile } from '../../interfaces/listini';
import { IRivenditore } from '../../interfaces/IRivenditore';

class DeleteRivenditoreModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack',
    '$state'
  ];

  private close: any;
  private dismiss: any;

  constructor(
    private $scope: {
      rivenditore:IRivenditore
      [key:string]:any
    },
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService,
    private $state: any
  ) {

    $scope.rivenditore = JSON.parse(JSON.stringify($scope.$parent.$resolve.rivenditore)) as IRivenditore

    $scope.ok = () => {
      $scope.messaggio = null;
      ArchiSmallServices.deleteRivenditore($scope.rivenditore._id).then(res=>{
        this.close({$value: true});
      }).catch(err=>{
        $scope.messaggio = `Errore durante l'eliminazione ${err.data.errorDescription}`
        console.log(err);
      })

    };
    $scope.annulla = () => {
      this.close({$value: false});
    };
  }
}

export const DeleteRivenditoreModalComponent: ng.IComponentOptions = {
  template: require('./delete-rivenditore-modal.html'),
  controller: DeleteRivenditoreModalController,
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/delete-rivenditore-modal/delete-rivenditore-modal.ts